/**
 * TabFilter — tab strip with optional count badges.
 * Extracted from FilterBar.jsx for reuse across filter configurations.
 *
 * A horizontal scroller, never wider than its parent: it used to be overflow:hidden +
 * nowrap, so on a phone the last tabs ("Confirmed", "All") were cut off and unreachable
 * (mobile overflow audit). useHorizontalScroll adds the edge fade and keeps the selected
 * tab in view.
 */
import useHorizontalScroll from '../../../hooks/useHorizontalScroll';

export default function TabFilter({ options = [], value, onChange, tabCounts }) {
  const scrollRef = useHorizontalScroll();
  return (
    <div
      ref={scrollRef}
      style={{
        display: 'flex',
        gap: 0,
        borderRadius: 8,
        overflowX: 'auto',
        overflowY: 'hidden',
        minWidth: 0,
        maxWidth: '100%',
        border: '1px solid var(--bdr)',
      }}
    >
      {options.map((opt) => {
        const k = typeof opt === 'string' ? opt : (opt.key ?? opt.value);
        const lbl = typeof opt === 'string' ? opt : (opt.label ?? k);
        const active = value === k;
        const count = tabCounts?.[k];
        return (
          <button
            key={k}
            aria-current={active ? 'true' : undefined}
            data-testid={`tab-filter-${k}`}
            onClick={() => onChange(k)}
            style={{
              flexShrink: 0,
              padding: '8px 14px',
              fontSize: 12,
              fontWeight: active ? 600 : 400,
              background: active ? 'var(--navy)' : 'var(--glass)',
              color: active ? 'var(--card)' : 'var(--t2)',
              border: 'none',
              borderRight: '1px solid var(--bdr)',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: 6,
              minHeight: 44,
              whiteSpace: 'nowrap',
            }}
          >
            {lbl}
            {count != null && (
              <span
                style={{
                  fontSize: 10,
                  fontWeight: 600,
                  background: active ? 'rgba(255,255,255,0.2)' : 'var(--bdr)',
                  borderRadius: 9999,
                  padding: '1px 6px',
                  minWidth: 18,
                  textAlign: 'center',
                }}
              >
                {count}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
